<template>
  <b-modal
    v-model="modalOpen"
    size="xl"
    centered
    title="معلومات محركي الحساب"
    footer-class="removed"
    class="edit-modal"
    static
  >
    <b-card-text>
      <b-list-group class="rounded">
        <b-list-group-item class="bg-info bg-lighten-2">
          <b-row class="text-white">
            <b-col> الاسم الثلاثي </b-col>
            <b-col> الرقم الوطني </b-col>
            <b-col> تاريخ التعيين </b-col>
            <b-col> </b-col>
          </b-row>
        </b-list-group-item>
        <template v-if="driversLoading">
          <div class="text-center text-info my-2">
            <b-spinner class="align-middle mx-2"></b-spinner>
            <strong>جاري التحميل...</strong>
          </div>
        </template>
        <template v-else>
          <template v-if="drivers.length === 0">
            <span class="text-center my-1" style="opacity: 0.7"
              >لا يوجد محركين لهذا الحساب</span
            >
          </template>
          <b-list-group-item
            v-for="(driver, index) in drivers"
            :key="driver.id"
          >
            <validation-observer ref="updateDriverValidation">
              <b-form @submit.prevent="onUpdate(driver, index)">
                <b-row v-if="isEdit === driver.id">
                  <b-col>
                    <form-input rules="required" v-model="toAdd.full_name"
                  /></b-col>
                  <b-col>
                    <form-cleave
                      v-model="toAdd.id_number"
                      isNumber
                      :charsCount="11"
                      rules="required|min:11"
                    />
                  </b-col>
                  <b-col>
                    <form-mask
                      placeholder="YYYY-MM-DD"
                      options="date"
                      id="assign-date"
                      v-model="toAdd.assign_date"
                    />
                  </b-col>
                  <b-col
                    class="justify-content-end d-flex pt-50 align-items-center"
                  >
                    <b-button
                      @click="
                        isEdit = -1;
                        toAdd = {};
                      "
                      variant="outline-secondary"
                      class=""
                    >
                      <feather-icon icon="XIcon" />
                      إلغاء
                    </b-button>
                    <save-btn
                      :loading.sync="driversWorking"
                      type="submit"
                      class="ml-1"
                      variant="primary"
                      style="height: 40px"
                    >
                    </save-btn>
                  </b-col>
                </b-row>
                <b-row v-else class="align-items-center">
                  <b-col> {{ driver.full_name }}</b-col>
                  <b-col> {{ driver.id_number }} </b-col>
                  <b-col> {{ driver.assign_date }} </b-col>
                  <b-col class="justify-content-end d-flex">
                    <b-button
                      v-can="{ slug: $route.meta.slug, action: 'U' }"
                      @click="onEdit(driver)"
                      variant="flat-primary"
                      class="btn-icon rounded-circle"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                      v-can="{ slug: $route.meta.slug, action: 'D' }"
                      @click="onDelete(driver.id)"
                      variant="flat-danger"
                      class="btn-icon rounded-circle"
                    >
                      <feather-icon icon="Trash2Icon" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-list-group-item>
          <b-list-group-item v-if="isAdding">
            <validation-observer ref="addDriverValidation">
              <b-form @submit.prevent="onAdd" ref="addDriverForm">
                <b-row>
                  <b-col>
                    <form-input
                      rules="required"
                      label="الاسم الثلاثي*"
                      v-model="toAdd.full_name"
                  /></b-col>
                  <b-col>
                    <form-cleave
                      label="الرقم الوطني*"
                      v-model="toAdd.id_number"
                      isNumber
                      :charsCount="11"
                      rules="required|min:11"
                    />
                  </b-col>
                  <b-col>
                    <form-mask
                      placeholder="YYYY-MM-DD"
                      options="date"
                      id="assign-date"
                      v-model="toAdd.assign_date"
                      label="تاريخ التعيين*"
                      rules="required"
                    />
                  </b-col>
                  <b-col
                    class="justify-content-end d-flex pt-50 align-items-center"
                  >
                    <b-button
                      @click="
                        isAdding = false;
                        toAdd = {};
                      "
                      variant="outline-secondary"
                      class=""
                    >
                      <feather-icon icon="XIcon" />
                      إلغاء
                    </b-button>
                    <save-btn
                      :loading.sync="driversWorking"
                      type="submit"
                      class="ml-1"
                      variant="primary"
                      style="height: 40px"
                    >
                    </save-btn>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-list-group-item>
        </template>
      </b-list-group>
    </b-card-text>
    <b-row
      class="px-1 d-flex justify-content-end"
      v-can="{ slug: $route.meta.slug, action: 'C' }"
    >
      <b-button
        :disabled="isAdding === true || isEdit !== -1"
        @click="
          toAdd = {};
          isAdding = true;
        "
        variant="success"
      >
        <feather-icon icon="PlusIcon" />
        <span> إضافة </span>
      </b-button>
    </b-row>
  </b-modal>
</template>

<script>
import Cleave from "vue-cleave-component";
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BModal,
  BFormGroup,
  BForm,
  BButton,
  BListGroup,
  BListGroupItem,
  BSpinner,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formInput from "@/components/form-input";
import FormCleave from "@/components/FormCleave";
import saveBtn from "@/components/loader-btn";
import { mapActions, mapGetters } from "vuex";
import FormMask from "@/components/form-mask";

export default {
  components: {
    formInput,
    Cleave,
    BButton,
    BListGroup,
    BListGroupItem,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BModal,
    BFormGroup,
    BForm,
    ValidationObserver,
    BSpinner,
    FormCleave,
    FormMask,
  },
  props: {
    value: Boolean,
    bankId: Number,
  },
  data() {
    return {
      form: {},
      toAdd: {},
      isEdit: -1,
      isAdding: false,
    };
  },
  computed: {
    ...mapGetters("NgoProfile/BankAccounts", [
      "drivers",
      "driversLoading",
      "driversWorking",
    ]),
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  created() {
    if (this.bankId) this.fetchDrivers(this.bankId);
  },
  watch: {
    bankId(val) {
      if (val) {
        this.fetchDrivers(val);
      }
    },
    modalOpen(val) {
      if (val) {
        this.toAdd = {};
      }
    },
  },
  methods: {
    ...mapActions("NgoProfile/BankAccounts", [
      "editDriver",
      "addDriver",
      "deleteDriver",
      "fetchDrivers",
    ]),
    onEdit(driver) {
      this.toAdd = { ...driver };
      this.isEdit = driver.id;
    },
    async onAdd() {
      await this.$refs.addDriverValidation.validate().then(async (success) => {
        if (success) {
          this.isAdding = false;
          await this.addDriver({ ...this.toAdd, bank_account_id: this.bankId });
          this.toAdd = {};
        }
      });
    },
    async onUpdate(driver, index) {
      await this.$refs.updateDriverValidation[index]
        .validate()
        .then(async (success) => {
          if (success) {
            await this.editDriver({
              id: driver.id,
              form: { ...this.toAdd, bank_account_id: this.bankId },
            });
            this.isEdit = -1;
            this.fetchDrivers(this.bankId);
            this.toAdd = {};
          }
        });
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف محرك الحساب؟", {
          title: "تأكيد حذف محرك الحساب",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteDriver(id);
            this.fetchDrivers(this.bankId);
          }
        });
    },
  },
};
</script>
